const e = "Aparthotels", n = "Wohnungen", s = "Geschäftlich", t = "Campings", o = "Pärchen", r = "Familie", i = "Freunde", l = "Hostels", a = "Hotels", u = "Resorts", c = "Restaurants", m = {
  "{num} reviews": "{num} Bewertungen",
  "<em>TOP {position}</em> {hotelType} in {location}": "<em>TOP {position}</em> {hotelType} in {location}",
  "All languages": "Alle Sprachen",
  "All traveler types": "Alle Arten von Reisenden",
  Aparthotels: e,
  Apartments: n,
  "Arrow icon": "Pfeil-Symbol",
  "B&Bs": "B&Bs",
  "based on {number} reviews": "basierend auf {number} Bewertungen",
  Business: s,
  Campsites: t,
  Couple: o,
  Family: r,
  Friend: i,
  "Highlighted reviews": "Hervorgehobene Bewertungen",
  Hostels: l,
  Hotels: a,
  "Information icon": "Informationssymbol",
  "No reviews found": "Keine Bewertungen verfügbar",
  "Pet-friendly": "Haustierfreundlich",
  "Posted on {reviewer}": "Verfasst in {reviewer}",
  "Read Reviews": "Bewertungen lesen",
  Resorts: u,
  Restaurants: c,
  "Review Summary": "Bewertungen",
  "Reviews by Source": "Bewertungen nach Quelle"
};
export {
  e as Aparthotels,
  n as Apartments,
  s as Business,
  t as Campsites,
  o as Couple,
  r as Family,
  i as Friend,
  l as Hostels,
  a as Hotels,
  u as Resorts,
  c as Restaurants,
  m as default
};
//# sourceMappingURL=de.BAdUYIig.js.map
